<div class="rs-document__wrapper">
	<div #documentRef
		*ngIf="!!htmlContent"
		class="rs-document"
		[innerHTML]="htmlContent | sanitizeHtml" (scroll)="onDocumentScroll($event)">
	</div>
</div>
